import { HiChevronDown } from 'react-icons/hi';

import './styles.css';

function NavItemMoreBtn({ _children, ...rest }) {
  return (
    <span className="nav-link">
      <button type="button" className="btn navbar-more-btn">
        <span className="navbar-more-btn-text">{rest.title}</span>
        <HiChevronDown style={{ marginLeft: '0.5rem', marginTop: '0.188rem' }} color="#785ea8" size={15} />
      </button>
    </span>
  );
}

export { NavItemMoreBtn };
